import {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react'

// The case page's frame tint (the Evie Operator mode colour) has to reach
// above the page: the layout column paints it so the fixed GlobalTopBar can
// sit on it transparently and the whole viewport reads as one surface.
// The shell publishes; the layout subscribes. Outside a provider (every
// other route family, most tests) publishing is a no-op and nothing paints.
interface App2FrameTint {
  background: string | null
  setBackground: (background: string | null) => void
}

const App2FrameTintContext = createContext<App2FrameTint>({
  background: null,
  setBackground: () => {},
})

export const App2FrameTintProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [background, setBackground] = useState<string | null>(null)
  const value = useMemo(() => ({ background, setBackground }), [background])
  return (
    <App2FrameTintContext.Provider value={value}>
      {children}
    </App2FrameTintContext.Provider>
  )
}

export const useApp2FrameTint = () => useContext(App2FrameTintContext)
